/**
 * Brand assets taken from 360face.pt (Tilda CDN, 09.10.2026). Later these come from
 * Hub Brand & Content Sync; the CSP allows images from static.tildacdn.com.
 */
export const BRAND = {
  logo: 'https://static.tildacdn.com/tild6665-3139-4133-a237-316230353338/logo_grey.png',
  heroImage: 'https://static.tildacdn.com/tild3738-6664-4761-b233-373938613637/noroot.png',
} as const;
